export default __webpack_public_path__ + "static/media/im.9efa572b.svg";